import { GMSpinner } from '../Spinner/Spinner';
import css from './LoadingOverlay.module.scss';
import React, { PropsWithChildren } from 'react';

interface ComponentProps extends PropsWithChildren {
    /**
     * zIndex the overlay should have
     */
    zIndex?: number;
    /**
     * Whether to show the loading overlay
     */
    loading: boolean;
}

export const GMLoadingOverlay: React.FC<ComponentProps> = (props) => {
    return (
        <div className={css.root}>
            {props.loading ?
                <div className={css.overlay} style={{ zIndex: props.zIndex }}>
                    <GMSpinner />
                </div> : null
            }
            <div className={css.content}>
                {props.children}
            </div>
        </div>
    );
};